import React from 'react';
import { QuoteIcon } from 'lucide-react';
import { SectionShell, SectionTitle } from '../SectionShell';
import { CTAButton } from '../CTAButton';
import { testimonials } from '../../data/content';
export function Testimonials() {
  return <SectionShell data-id="element-232" data-mp="3mf7ly4stt268">
      <SectionTitle eyebrow="⭐ What clinicians are looking for" title="“I don’t need another place to store information. I need to find the information I need.”" data-id="element-233" data-mp="3mepnd1ioybv5" />

      <div className="mb-8 rounded-xl border-l-4 border-sky-400 bg-navy-950 p-5" data-id="element-234" data-mp="fykraun1tu">
        <p className="text-sm leading-relaxed text-sky-100/75" data-id="element-235" data-mp="421fcnqi809b">
          That’s the philosophy behind the TRT Decision Deck™. It wasn’t designed around hundreds of
          pages. It was designed around the questions and scenarios that arise during a TRT
          consultation.
        </p>
      </div>

      <ul className="grid gap-4 sm:grid-cols-2" data-id="element-236" data-mp="2auamzn137o97">
        {testimonials.map(testimonial => <li key={testimonial.name} className="flex h-full flex-col rounded-2xl border border-sky-400/15 bg-navy-800 p-5" data-id="element-237" data-mp="2ftewkerxbo02">
            <QuoteIcon className="h-6 w-6 text-sky-400" aria-hidden="true" data-id="element-238" data-mp="1ntszx29172ru" />
            <p className="mt-3 text-sm leading-relaxed text-white" data-id="element-239" data-mp="1nrpxfiqozh68">“{testimonial.quote}”</p>
            <div className="mt-auto flex items-center gap-3 pt-5" data-id="element-240" data-mp="1iuzi4xmpoplv">
              <img src={testimonial.image} alt={testimonial.name} className="h-12 w-12 shrink-0 rounded-full object-cover ring-2 ring-sky-400/40" data-id="element-241" data-mp="1eu5tu35cx8sg" />
              <div className="min-w-0" data-id="element-242" data-mp="26llpsnst07vc">
                <p className="text-sm font-semibold text-white" data-id="element-243" data-mp="26ihhpfc7wrze">{testimonial.name}</p>
                <p className="text-xs leading-snug text-sky-100/60" data-id="element-244" data-mp="22ktg5tg0s0yj">{testimonial.role}</p>
              </div>
            </div>
          </li>)}
      </ul>

      <div className="mt-8" data-id="element-245" data-mp="r4l8xepn81gj">
        <CTAButton label="I want a clearer consultation workflow" subline="$27 one-time · Lifetime access" data-id="element-246" data-mp="r4v3zgpjoyt3" />
      </div>
    </SectionShell>;
}